import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { epicsErrorHandler } from '../../../epics'

import { fetchDataError, fetchDataSuccess } from './actions'
import { DATA_REQUEST_ASYNC } from './constants'

const fetchDataEpic = (action$, store, { api }) =>
  action$.ofType(DATA_REQUEST_ASYNC.INITIATE).mergeMap((action) =>
    api.resolutionCenter
      .getScannerDetail(action.payload.elem)
      .map((response) => fetchDataSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(fetchDataError, error)))
      .takeUntil(action$.ofType(DATA_REQUEST_ASYNC.CANCEL))
  )

export default combineEpics(fetchDataEpic)
